import { useStarterDashboardV2PageData } from '#src/app/pages/starterDashboardV2/pageContext';

type UseTaskReturn = ModelHookResult<{
	showMultiDownloadFlyersTask: boolean;
}>;
export function useTask(): UseTaskReturn {
	const {
		data: {
			featureConfigs: { multipleQrCodeFlyersEnabled },
		},
	} = useStarterDashboardV2PageData();
	const showMultiDownloadFlyersTask = multipleQrCodeFlyersEnabled;

	return {
		data: {
			showMultiDownloadFlyersTask,
		},
	};
}
